import classNames from "classnames";
import { useNavigate } from "react-router";
import { mergeClass } from "../utils";
import { useAtomValue } from "jotai";
import { uploadListAtom } from "../atoms";
export interface IButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  readonly className?: string;
}
const Button = ({
  className,
  children,
  disabled,
  type,
  ...restProps
}: IButtonProps): JSX.Element => {
  return (
    <button
      className={mergeClass(
        "px-5 py-2 grid bg-primaryColor border-primaryColor border text-white font-medium",
        "transition hover:bg-white hover:text-primaryColor hover:border-primaryColor",
        { "opacity-50 pointer-events-none": disabled },
        className
      )}
      type={type}
      disabled={disabled}
      {...restProps}
    >
      {children}
    </button>
  );
};

const BackButton = (): JSX.Element => {
  const navigate = useNavigate();
  return (
    <Button onClick={() => navigate(-1)}>
      <span>
        <i className="icon-back_arrow mr-1 text-sm" /> Back
      </span>
    </Button>
  );
};

const EditButton = (props: IButtonProps) => (
  <Button {...props}>
    <span>
      <i className="icon-edit mr-1 text-sm" /> Edit
    </span>
  </Button>
);

/**
 * Exclusively for making save item requests.
 * Will check against uploadListAtom to prevent submission during upload.
 * Will check against base-form id unless specified in the form prop
 * @param param0
 * @returns
 */
const SaveButton = ({ type, form, ...props }: IButtonProps): JSX.Element => {
  const uploadList = useAtomValue(uploadListAtom);
  const uploading = uploadList.length > 0;
  return (
    <div className="flex gap-2">
      {uploading && (
        <div className="place-self-center">
          Please wait for upload to finish before saving
        </div>
      )}
      <Button
        id="base-form-submit"
        type={type || "submit"}
        form={form || "base-form"}
        {...props}
        disabled={uploading}
      >
        <span>
          <i className="icon-edit mr-1 text-sm" /> Save
        </span>
      </Button>
    </div>
  );
};

const DeleteButton = ({ className, ...restProps }: IButtonProps) => (
  <Button
    className={classNames("bg-warningRed border-warningRed flex", className)}
    {...restProps}
  >
    <i className="icon-delete mr-1 text-sm" />
    <span className="place-self-center">Delete</span>
  </Button>
);

const UploadButton = ({ className, ...restProps }: IButtonProps) => (
  <Button
    className={classNames("bg-actionGreen border-actionGreen", className)}
    {...restProps}
  >
    <span>Upload</span>
  </Button>
);

const AddButton = ({ className, ...restProps }: IButtonProps) => (
  <Button className={classNames("", className)} {...restProps}>
    <span>
      <i className="icon-plus mr-1 text-sm" /> Add
    </span>
  </Button>
);

export {
  Button,
  BackButton,
  SaveButton,
  DeleteButton,
  EditButton,
  UploadButton,
  AddButton,
};
